module.exports = __webpack_public_path__ + "static/logo.5b9a7a21.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/logo.png
// module id = 293
// module chunks = 3